if (!customElements.get('header-tabs')) {
  class HeaderTabs extends HTMLElement {
    connectedCallback() {
      const languageSelector = this.querySelector('.header-tabs__language');
      if (!languageSelector) return;

      document.fonts.ready.then(() => {
        this.style.setProperty('--tabs-language-width', `${languageSelector.getBoundingClientRect().width}px`);
      });
    }
  }

  customElements.define('header-tabs', HeaderTabs);
}